import React from "react"
import { formatText } from "../../../../v1/helpers/stringHelpers"
import StarIcon from "../../../../images/star_icon.svg"
import ReactSVG from "react-svg"
import { Button, Image } from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import EmptyShopLogo from "../../../../images/empty_shop_logo.svg"
import { MD_HD_VEHICLE_TYPE_ID } from "../../../../v1/constants/application"
import { getActiveVehicle } from "../../../../v1/helpers/vehicleHelpers"
import { connect } from "react-redux"
import { numberFormatToCurrency } from "../../../../shared_component/utils/currency"
import { PricedAtShop } from "../PricedAtShop"
import { CA } from "../../../../v1/constants/states"

const SelectShops = ({ shop, user, cart, selectedShop, handleShopSelection, isSubmitting }) => {
  const { t } = useTranslation("affiliationShopSelection")

  let vehicleTypeId
  if (user) {
    const activeVehicle = getActiveVehicle()
    vehicleTypeId = (activeVehicle && activeVehicle.vehicle_type_id) || null
  }
  const showPrices = () => {
    if (!shop.price_estimates || shop.price_estimates.length === 0) {
      return false
    }

    let show = shop.price_estimates.some(
      (e) => e.shop_price_estimate !== null && (e?.shop_price_estimate?.length || 0) > 0
    )

    return show && !shop.company.pricing_disabled && vehicleTypeId !== MD_HD_VEHICLE_TYPE_ID
  }

  const retailPrice = () => {
    if (!shop.price_estimates || shop.price_estimates.length === 0) {
      return false
    }

    const validPrices = shop.price_estimates
      .map((e) => Number(e.shop_price_estimate))
      .filter((price) => !isNaN(price))

    if (validPrices.length === 0) {
      return false
    }

    const priceTotal = validPrices.reduce((sum, price) => sum + price, 0)
    const totalWithRetailSavings = priceTotal + (shop.total_retail_savings || 0)

    return numberFormatToCurrency(totalWithRetailSavings.toString())
  }

  const shopDisplayPrice = () => {
    if (!shop.price_estimates || shop.price_estimates.length === 0) {
      return t("common:priceAtShopLbl")
    }

    const validPrices = shop.price_estimates
      .map((e) => Number(e.shop_price_estimate))
      .filter((price) => !isNaN(price))

    if (validPrices.length === 0) {
      return t("common:priceAtShopLbl")
    }

    const totalPrice = validPrices.reduce((sum, price) => sum + price, 0)

    return numberFormatToCurrency(totalPrice.toString())
  }

  const isSelectedShop = selectedShop?.id === shop?.id
  const isComparePriceFlow = localStorage.getItem("isComparePriceFlow") === "true"
  return (
    <div className={`instacart-shops ${isSelectedShop ? "selected-shop-border" : ""}`}>
      <div className="shop-rating-users">
        <div className="shop-rating-box shop-rating-star">
          <ReactSVG src={StarIcon} />
          <p className="shop-rating">
            {shop?.average_rating || "--"} {shop.rating ? `(${shop.rating})` : ""}
          </p>
        </div>
        <div className="shop-rating-box walk-in-only-bg">
          <p className="shop-caradvisors">
            {formatText(
              t("carAdvisors", {
                CAR_ADVISORS: shop.completed_shop_orders_count || "--"
              }),
              "shop-caradvisors-span"
            )}
          </p>
        </div>
      </div>
      <div className="shop-details">
        <Image className="shop-logo" src={shop.logo_url ? shop.logo_url : EmptyShopLogo} />
        <div className="shop-info">
          <p className="shop-name">{shop.name}</p>
          <p className="shop-address">
            {formatText(
              t("shopInfo", {
                ADDRESS: `${shop.address_line1}, ${shop.city}, ${shop.state} ${shop.zip}`,
                MILES: shop.distance_config.display_value_abbr
              }),
              "shop-address-span"
            )}
          </p>
        </div>

        {/* Shop Price Details */}
        <div className="shop-price-details">
          {showPrices() ? (
            <div className="shopPriceContainer">
              <p className="discount-price">
                {t("startingAt")} {shopDisplayPrice()}
              </p>
              {shop.total_retail_savings > 0 && <p className="original-price">{retailPrice()}</p>}
            </div>
          ) : (
            <PricedAtShop fontSize={14} />
          )}
        </div>
      </div>
      {isComparePriceFlow ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Button
            onClick={() => handleShopSelection(shop, true)}
            className={isSelectedShop ? "instacart-shop-selected" : "instacart-shop-select"}
          >
            {t("addService:startBooking")}
          </Button>
          <Button onClick={() => handleShopSelection(shop)} className="see-price-details-btn">
            {t("See price details")}
          </Button>
        </div>
      ) : (
        <Button
          onClick={() => handleShopSelection(shop)}
          className={isSelectedShop ? "instacart-shop-selected" : "instacart-shop-select"}
        >
          {t("selectShop")}
        </Button>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  const user = state.user
  const cart =
    user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)

  return {
    user: state.user,
    cart: cart
  }
}

export default connect(mapStateToProps)(SelectShops)
